import { render, staticRenderFns } from "./add-holder-dollar-dialog.vue?vue&type=template&id=51c43a71&scoped=true&"
import script from "./add-holder-dollar-dialog.vue?vue&type=script&lang=js&"
export * from "./add-holder-dollar-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-holder-dollar-dialog.vue?vue&type=style&index=0&id=51c43a71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c43a71",
  null
  
)

export default component.exports